import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function ConfirmModal(props: any) {
  const { confirm } = props;
  const { t } = useTranslation();

  const [show, setShow] = useState(confirm.show);
  function closeConfirm() {
    setShow(false);
  }

  return (
    <Modal
      show={show}
      onHide={() => closeConfirm}
      className="modal-confirm-wrapper"
    >
      <Modal.Body>
        <Modal.Title>{t(confirm["title"])}</Modal.Title>
        <p className="modal-description">{t(confirm["description"])}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={confirm["confirmStatus"] || "primary"}
          onClick={(e) => {
            confirm["confirmAction"]();
            closeConfirm();
          }}
        >
          {t(confirm["confirmText"])}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmModal;
